import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AdalService } from './adal.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {
	constructor(private router: Router, private adalService: AdalService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		const navigationExtras: NavigationExtras = {
			queryParams: { 'redirectUrl': route.url }
		};

		if (!this.adalService.userInfo) {
			this.router.navigate([''], navigationExtras);
		}

		return true;
	}
}
